import React, { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ResourceRequestWrapper } from 'api/resource-request/types';
import { formatterWithMinutes } from 'components/atoms/input-duration/formatter';
import { Extra } from 'components/molecules/squad-picker';
import { RoutePaths } from 'constant';
import { useUser } from 'hooks/use-user';
import { useResourceManagementConfigQuery } from 'queries/resource-management-configuration';

export const AllocatedHours: FC<{ minutes: number }> = ({ minutes }) => {
  const allocatedHours = useMemo(
    () => formatterWithMinutes(minutes),
    [minutes],
  );

  return <span>{allocatedHours}</span>;
};

export const ResourceRequestLink: FC<{
  resourceRequestWrapper: ResourceRequestWrapper;
  children: React.ReactNode;
}> = ({ resourceRequestWrapper, children }) => {
  const { resourceRequestType, status, resourceRequestMappingId } =
    resourceRequestWrapper;
  const { data } = useResourceManagementConfigQuery();
  const { user } = useUser();
  const userTypePathString: 'requestor' | 'approver' =
    data?.resourceApproverIds?.includes(user?.userId)
      ? 'approver'
      : 'requestor';

  const requestTypePathString = resourceRequestType
    ?.toLowerCase()
    ?.replace?.(/_/g, '-');

  let url = `${RoutePaths.resourceRequest}/${userTypePathString}/${requestTypePathString}`;

  if (
    ['TODO', 'BLOCKED'].includes(status) &&
    userTypePathString === 'approver'
  ) {
    const statusPath = status === 'APPROVED' ? 'approval' : 'blocked';

    url = `${url}/${statusPath}/${resourceRequestMappingId}`;
  } else if (status === 'APPROVED' || userTypePathString === 'requestor') {
    url = `${url}/${resourceRequestMappingId}/view`;
  }

  return <Link to={url}>{children}</Link>;
};

export const extractTeamIdAndReferenceTeamId = ({
  type,
  id,
  teamId,
}: Extra & {
  teamId?: number;
}) => {
  if (type === 'user' && teamId) {
    return [teamId];
  }

  // if its user return undefined
  if (type === 'team') {
    return [id];
  }

  return undefined;
};
